import { render, staticRenderFns } from "./ContactGroupMembers.vue?vue&type=template&id=dba648b2&scoped=true"
import script from "./ContactGroupMembers.vue?vue&type=script&lang=js"
export * from "./ContactGroupMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba648b2",
  null
  
)

export default component.exports